module.exports = __webpack_public_path__ + "img/img_hospital.48f29f19.jpg";